<div class="mainpage-image-wrapper">
  <img alt="Welcome to Profile Deutsch" class="mainpage-image" height="448" src="../../../../assets/images/mainpage-image.jpg" width="1540"/>
</div>

<div class="mainpage-content-wrapper-wrapper">
  <div class="mainpage-content-wrapper">
    <div class="info-text-wrapper">
      <span class="mat-display-1 bold-blue mainpage-headline">DEUTSCHLEHREN LEICHT GEMACHT</span>

      <span class="mainpage-text">
        <span class="bold-blue">PROFILE DEUTSCH</span>
        <span>
          ist ein Hilfsmittel für Entwickler/-innen von Curricula, Leiter/-innen von Bildungsinstitutionen,
          Lehrbuchautoren/-innen, Prüfungsspezialisten/-innen, Arbeitgeber/-innen, Testentwickler/-innen,
          Lehrende und Lernende.
        </span>
      </span>

      <span class="mainpage-text">
        <span class="bold-blue">PROFILE DEUTSCH</span>
        <span>
          ermöglicht Sprachniveaus und Lernziele der Lernenden zu bestimmen, Unterrichtsmaterialien und Prüfungen zu
          erstellen und zu kombinieren, Listen zu Lernzielen, Lernstoff und Lernstrategien zu verfassen sowie den
          konkreten Unterricht zu planen und zu evaluieren.
        </span>
      </span>

      <span class="mainpage-text">
        <span class="bold-blue">PROFILE DEUTSCH</span>
        <span>
          beschreibt für Deutsch als Fremdsprache und Deutsch als Zweitsprache die handlungsorientierten Anforderungen
          der Niveaustufen des Gemeinsamen Europäischen Referenzrahmens mit konkreten Beispielen.
        </span>
      </span>
    </div>
  </div>
</div>

<div class="mainpage-cards-wrapper-wrapper">
  <div class="mainpage-cards-wrapper">
    <mat-card class="mainpage-cards">
      <span class="mat-display-1 bold-blue mainpage-subheading">GER</span>
      <span class="mainpage-text mainpage-text-smaller-margin">
        Der Gemeinsame Europäische Referenzrahmen für Sprachen liefert eine gemeinschaftliche Grundlage, die den Spracherwerb, die Sprachanwendung und die Sprachkompetenz von Lernenden transparent und vergleichbar macht.
      </span>
      <button mat-flat-button [routerLink]="['']" class="mainpage-link mainpage-text">weiterlesen ...</button>
    </mat-card>
    <mat-card class="mainpage-cards">
      <span class="mat-display-1 bold-blue mainpage-subheading">6 NIVEAUS</span>
      <span class="mainpage-text mainpage-text-smaller-margin">
        Die 6 Niveaustufen des GER beschreiben die sprachlichen Kompetenzen eines Lernenden in den vier Fertigkeiten Lesen, Hören, Sprechen und Schreiben.
      </span>
      <button mat-flat-button [routerLink]="['']" class="mainpage-link mainpage-text">weiterlesen ...</button>
    </mat-card>
    <mat-card class="mainpage-cards">
      <span class="mat-display-1 bold-blue mainpage-subheading">KANNBESCHREIBUNGEN</span>
      <span class="mainpage-text mainpage-text-smaller-margin">
        Die Niveaubeschreibungen präzisieren, welche sprachlichen Handlungen Lernende auf einem bestimmten Niveau ausführen können.
      </span>
      <button mat-flat-button [routerLink]="['']" class="mainpage-link mainpage-text">weiterlesen ...</button>
    </mat-card>
  </div>
</div>
